'use client'

import React, { FC, ReactNode, useEffect, useState } from 'react'
import { QueryClientProvider } from 'react-query'
import { BrowserRouter } from 'react-router-dom'

import { configurePersistable } from 'mobx-persist-store'

import { queryClient } from '../../../shared/api/query-client'
import { browserStorage } from '../../../shared/storage/browserStorage'

export const AppProvider: FC<{ children?: ReactNode }> = ({ children }) => {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)

    const originalPushState = window.history.pushState
    const originalReplaceState = window.history.replaceState
    let isHardNavigating = false

    window.history.pushState = function (...args) {
      const previousUrl = window.location.href
      originalPushState.apply(this, args as Parameters<History['pushState']>)
      const nextUrl = window.location.href

      if (!isHardNavigating && nextUrl !== previousUrl) {
        isHardNavigating = true
        window.location.assign(nextUrl)
      }
    }

    window.history.replaceState = function (...args) {
      const previousUrl = window.location.href
      originalReplaceState.apply(this, args as Parameters<History['replaceState']>)
      const nextUrl = window.location.href

      if (!isHardNavigating && nextUrl !== previousUrl) {
        isHardNavigating = true
        window.location.replace(nextUrl)
      }
    }

    configurePersistable(
      {
        debugMode: true,
        expireIn: 86400000,
        removeOnExpiration: true,
        storage: browserStorage,
        stringify: false,
      },
      { delay: 200, fireImmediately: false }
    )

    return () => {
      window.history.pushState = originalPushState
      window.history.replaceState = originalReplaceState
    }
  }, [])

  if (!isMounted) {
    return null
  }

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>{children}</BrowserRouter>
    </QueryClientProvider>
  )
}
